<div class="card h-100">
  <div class="card-header d-flex justify-content-between align-items-start border-0 bg-transparent p-3">
    <div>
      <h5 class="card-title mb-0">Problem Child Patches</h5>
      <p class="text-muted small mb-0">Vulnerabilities recurring week over week</p>
    </div>
    <div class="last-updated-indicator">
      <small class="text-muted" (valueChange)="last_fetch_datetime()">
        <span style="color: #64748b; font-weight: 400">Last updated:</span>
        {{ last_fetch_datetime() | date: 'short' }}
      </small>
    </div>
  </div>
  <div class="table-responsive">
  <app-datatable [columns]="this.datatableColumns" [data-href]="this.datatableUrl" [successCallback]="this.onSuccess()" [initialFilters]="filters()"></app-datatable>
  </div>
</div>
